import React, {useState, useEffect} from 'react';

import './Login.css';
import Hosts from '../../Hosts'

import {

	repo_logo_link,
	repo_img_link,
  set_language,
} from '../../Utils';


// or
//import { Tabs } from '@material-ui/core';
import LoginForm from "./LoginForm";

import { language } from '../WEBContent/Language';

const Login = ({ setToken }) => {

  const [lang, set_lang] = useState('pt');

  const change_lang = (l) => {
      set_language(l)
      set_lang(l)
      window.location.reload()

      //console.log('language', localStorage.getItem('lang'))
      //console.log('localstorage', localStorage)
  }

useEffect(() => {

    if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
        change_lang('pt')
    }
    else {
        set_lang(localStorage.getItem('lang'))
    }

    //console.log('language', localStorage.getItem('lang'))
    //console.log('localstorage', localStorage)


}, [])



  return (
    <div id="login">

      <div className="login-wrapper" style={{
          backgroundImage: `url(` + repo_img_link("concrete_seamless.png") + `)`,
          backgroundRepeat: 'repeat',
          backgroundPosition: 'top center',
          backgroundAttachment: 'fixed',
          backgroundColor: '#f7f7f7'
        }}>
        
        <div className="div-left d-none" style={{
          backgroundImage: `url(` + repo_img_link("img-login.jpg") + `)`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}>

        </div>
        
        <div className="div-right">
          <div className='div-login-form'>
            <div className="language-selector d-none">
                <button  className={"language " + (lang === 'pt' ? 'assec-current-lang': '')} onClick={() => change_lang('pt')}>PT</button>
                <span className='assec-pr-5 assec-pl-5'>|</span>
                <button  className={"language " + (lang === 'en' ? 'assec-current-lang': '') } onClick={() => change_lang('en')}>EN</button> 
            </div> 

            <div className="form-header">
              <a href={Hosts.WEB_SITE_URI} rel="noreferrer" target="_blank">
                <img alt='' src={repo_logo_link("logo.svg")} style={{width: '180px'}} />      
              </a>      
            </div>

            <div className="div-form">
                
              <LoginForm setToken={setToken} loginType='login' />            
            </div>
            <div className="form-footer">
            </div>
          </div>
          <div className='mt-3 text-center'>
            <small className=''><a href="/terms-conditions" title={language[lang].terms_conditions} alt={language[lang].terms_conditions} target="_blank" rel="noreferrer" className="pl-1">{language[lang].terms_conditions}</a></small>
            <small className='mx-2'>|</small>
            <small className=''><a href="/privacy-policy" title={language[lang].privacy_policy} alt={language[lang].privacy_policy} target="_blank" rel="noreferrer" className="pl-1">{language[lang].privacy_policy}</a></small>
            <small className='mx-2'>|</small>
            <small className=''><a href="/cookie-policy" title={language[lang].cookie_policy} alt={language[lang].cookie_policy} target="_blank" rel="noreferrer" className="pl-1">{language[lang].cookie_policy}</a></small>
          </div>
          <div className='mt-1 text-center'>
            <small>{language[lang].developed} <a href="http://sim.assec.pt" title="Assec Sim!" alt="Assec Sim!" target="_blank" rel="noreferrer" className="pl-1">Assec Sim!</a></small>
          </div>
        </div>
      </div>

    </div>

  );

}

export default Login;

